module.exports = __webpack_public_path__ + "img/Mega-40-Party-Bus-1.jpg.94e64fb9.webp";